import React from 'react';
import { Stack } from '@curves/ui-base';
import {NavLink} from 'react-router-dom';
import clsx from 'clsx';
/**
 * [元件] InfoCard - 基礎資訊卡片容器（純 UI）
 *
 * 用途：
 * - 作為資料展示區塊的外層容器，例如：產品卡片、會員卡片、裝置卡片等
 * - 支援點擊行為或導頁功能
 * - 採用 `Stack` 排版，預設為橫向對齊（justify start）
 *
 * 功能：
 * - 若有傳入 `link`，則自動以 `<NavLink>` 包裝，具備路由跳轉功能
 * - 若有傳入 `onClick`，整個卡片會具備點擊事件
 * - 可接受任意 children，讓使用者自由放入內容
 *
 * @component
 * @param {Object} props
 * @param {string} [props.className] - 自定義的 CSS 類名
 * @param {string} [props.link] - 若有傳入，會使用 NavLink 導頁（通常用於列表點進詳情）
 * @param {function} [props.onClick] - 點擊事件處理函式（若無 link 則以此為主）
 * @param {React.ReactNode} props.children - 要包在卡片內的內容
 *
 * @example
 * <InfoCard link={`/products/123`}>
 *   <ProductCardContent />
 * </InfoCard>
 *
 * @example
 * <InfoCard onClick={handleClick}>
 *   <MemberSummary name="IU" />
 * </InfoCard>
 *
 * @returns {JSX.Element}
 */
const InfoCard = ({className, link, onClick, children, ...rest}) => {
    const containerProps = {
        className: clsx('info-card', className),
        component: 'div',
        justifyContent: 'start',
        alignItems: 'center',
        onClick,
        ...rest
    }
    if (link) {
        containerProps.component = NavLink;
        containerProps.to = link;
    }
    return <Stack {...containerProps}>{children}</Stack>;
};
export default InfoCard;
